import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  GreenDotWithTick,
  RedWithTick,
  Quality,
  QualityText
} from './Feedback.style';
import {FEEDBACK, REVIEW_OPTIONS} from '../../constants/constant';

export class ChosenQuality extends Component {
  constructor(props) {
    super(props);
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler() {
    const {quality, chooseQualityCallback} = this.props;
    chooseQualityCallback(quality);
  }

  render() {
    const {quality, rating, chosenQualities} = this.props;
    const renderGreenDot = rating === FEEDBACK.WOULD_ORDER_AGAIN &&
      <GreenDotWithTick selected={chosenQualities && !!chosenQualities[quality]} />;
    const renderRedDot = rating === FEEDBACK.WOULD_NOT_ORDER_AGAIN &&
      <RedWithTick selected={chosenQualities && !!chosenQualities[quality]} />;
    return (
      <Quality
        key={quality}
        onClick={this.onClickHandler}
      >
        {renderGreenDot}
        {renderRedDot}
        <QualityText>{REVIEW_OPTIONS[quality]}</QualityText>
      </Quality>
    );
  }
}

ChosenQuality.propTypes = {
  quality: PropTypes.string.isRequired,
  rating: PropTypes.string.isRequired,
  chosenQualities: PropTypes.object,
  chooseQualityCallback: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./containers/FeedbackPage/ChosenQuality.js